<template>
  <div class="cta-subsection">
    <div class="cta-content">
      <h2 class="cta-title">Prêt à transformer votre commerce floral ?</h2>
      <p class="cta-description">
        Rejoignez les fleuristes qui réussissent avec Florisuite. Commencez votre essai gratuit ou contactez notre équipe pour une démonstration personnalisée.
      </p>
      <div class="cta-buttons">
        <router-link class="cta-button primary" to="/inscription">
          <span class="cta-button-text">Démarrer l'essai gratuit</span>
        </router-link>
        <router-link class="cta-button secondary" to="/contact">
          <span class="cta-button-text">Contacter le Support</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CTASubsection",
});
</script>

<style>
.cta-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.cta-subsection .cta-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 25px;
  max-width: 1200px;
  min-width: 350px;
  width: 100%;
}

.cta-subsection .cta-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0;
  text-align: center;
  width: 100%;
}

.cta-subsection .cta-description {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  margin: 0;
  max-width: 835px;
  text-align: center;
  width: 100%;
}

.cta-subsection .cta-buttons {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
  justify-content: center;
  width: 100%;
}

.cta-subsection .cta-button {
  all: unset;
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 44px;
  overflow: hidden;
  padding: 12px 20px;
  position: relative;
  transition: all 0.2s ease;
}

.cta-subsection .cta-button.primary {
  background-color: #084734;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  flex: 1;
  max-width: 300px;
  min-width: 200px;
}

.cta-subsection .cta-button.secondary {
  background-color: #fafafa;
  border: 1px solid #deead8;
  width: 205.969px;
}

.cta-subsection .cta-button-text {
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  position: static;
  text-align: center;
  white-space: normal;
}

.cta-subsection .cta-button.primary .cta-button-text {
  color: #ffffff;
}

.cta-subsection .cta-button.secondary .cta-button-text {
  color: #1a1a1a;
}

@media (max-width: 768px) {
  .cta-subsection .cta-content {
    min-width: 0;
  }

  .cta-subsection .cta-title {
    font-size: 30px;
    line-height: 1.2;
  }

  .cta-subsection .cta-description {
    font-size: 16px;
    line-height: 1.45;
  }

  .cta-subsection .cta-buttons {
    flex-direction: column;
    gap: 12px;
  }

  .cta-subsection .cta-button {
    width: 100%;
    max-width: none;
    min-width: 0;
  }
}
</style>
